import $ from 'jquery';
import ScrollTrigger from 'gsap/ScrollTrigger';
import gsap from 'gsap';

class Gsap {
	constructor() {
		gsap.registerPlugin(ScrollTrigger);
		gsap.config({
			nullTargetWarn: false,
		});

		this.stickyHeader();
		this.footerAnimation();
	}

	footerAnimation() {
		gsap.from('.footer .cta',
			{
				scrollTrigger: {
					trigger: '.footer .cta',
					start: 'top bottom',
				},
				opacity: .8,
				scale: 1,
				duration: 1,
			});
		gsap.from('.footer .cta__title',
			{
				scrollTrigger: {
					trigger: '.footer .cta',
					start: 'top bottom',
				},
				y: 50,
				duration: .5,
			});
		gsap.from('.footer .cta .button',
			{
				scrollTrigger: {
					trigger: '.footer .cta',
					start: 'top bottom',
				},
				opacity: .5,
				scale: .8,
				y: 100,
				duration: .5,
			});
		gsap.from('.footer .cta .dec--1',
			{
				scrollTrigger: {
					trigger: '.footer .cta',
					start: 'top bottom',
				},
				scale: .8,
				duration: .5,
			});
		gsap.from('.footer-content',
			{
				scrollTrigger: {
					trigger: '.footer-content',
					start: 'top bottom',
				},
				opacity: 0,
				y: 10,
				duration: 1,
			});
		gsap.from('.footer-content .newsletter',
			{
				scrollTrigger: {
					trigger: '.footer-content',
					start: 'top bottom',
				},
				opacity: 0,
				duration: 1,
			});
		gsap.from('.footer-content .footer-col-1',
			{
				scrollTrigger: {
					trigger: '.footer-content',
					start: 'top bottom',
				},
				opacity: 0,
				duration: .5,
				delay: 0
			});
		gsap.from('.footer-content .footer-col-2',
			{
				scrollTrigger: {
					trigger: '.footer-content',
					start: 'top bottom',
				},
				opacity: 0,
				duration: .5,
				delay: .1
			});
		gsap.from('.footer-content .footer-col-3',
			{
				scrollTrigger: {
					trigger: '.footer-content',
					start: 'top bottom',
				},
				opacity: 0,
				duration: .5,
				delay: .2
			});
		gsap.from('.social',
			{
				scrollTrigger: {
					trigger: '.social',
					start: 'top bottom',
				},
				opacity: 0,
				duration: 2,
			});



		/**
		 * Hero pages
		 */
		gsap.from('.hero-pages .title',
			{
				scrollTrigger: {
					trigger: '.hero-pages',
				},
				y: 50,
				duration: .8,
			});
		gsap.from('.hero-pages .description',
			{
				scrollTrigger: {
					trigger: '.hero-pages',
				},
				y: 50,
				duration: .8,
			});
		gsap.from('.hero-pages .img',
			{
				scrollTrigger: {
					trigger: '.hero-pages',
				},
				opacity: 0,
				x: -50,
				y: 100,
				scale: .8,
				duration: 1,
			});
		gsap.from('.hero-pages .dec--1',
			{
				scrollTrigger: {
					trigger: '.hero-pages',
				},
				y: -150,
				x: -100,
				scale: .2,
				opacity: 0,
				duration: .8,
				delay: .2
			});
		gsap.from('.hero-pages .dec--2',
			{
				scrollTrigger: {
					trigger: '.hero-pages',
				},
				x: -300,
				scale: .2,
				opacity: 0,
				duration: .8,
				delay: .2
			});
		gsap.from('.hero-pages .dec--3',
			{
				scrollTrigger: {
					trigger: '.hero-pages',
				},
				x: -150,
				y: 300,
				scale: .2,
				opacity: 0,
				duration: .8,
				delay: .2
			});
		gsap.from('.hero-pages .dec--4',
			{
				scrollTrigger: {
					trigger: '.hero-pages',
				},
				y: -150,
				x: 100,
				scale: .2,
				opacity: 0,
				duration: .8,
				delay: .2
			});
		gsap.from('.hero-pages .dec--5',
			{
				scrollTrigger: {
					trigger: '.hero-pages',
				},
				y: 150,
				x: 300,
				scale: .2,
				opacity: 0,
				duration: .8,
				delay: .2
			});
		gsap.from('.hero-pages .dec--6',
			{
				scrollTrigger: {
					trigger: '.hero-pages',
				},
				y: 150,
				x: 300,
				scale: .2,
				opacity: 0,
				duration: .8,
				delay: .2
			});
		gsap.from('.hero-pages .dec--7',
			{
				scrollTrigger: {
					trigger: '.hero-pages',
				},
				y: 0,
				x: 0,
				scale: .2,
				opacity: 0,
				duration: .8,
				delay: .2
			});
		gsap.from('.hero-pages .dec--8',
			{
				scrollTrigger: {
					trigger: '.hero-pages',
				},
				y: 0,
				x: 0,
				scale: .2,
				opacity: 0,
				duration: .8,
				delay: .2
			});

		/**
		 * Thumb
		 */

		gsap.from('.thumb__img',
			{
				scrollTrigger: {
					trigger: '.thumb',
				},
				y: 20,
				opacity: 0,
				duration: .8,
				delay: .2
			});
		gsap.from('.thumb__title',
			{
				scrollTrigger: {
					trigger: '.thumb',
				},
				y: 20,
				duration: .8,
				delay: .3
			});

		/**
		 * Scroll
		 */
		const scroll = gsap.utils.toArray('.scroll');
		scroll.forEach(item => {
			gsap.from(item, {
				scrollTrigger: {
					trigger: item,
					start: 'top bottom',
				},
				scaleY: 0,
				duration: 1,
				delay: .1
			});
		});
	}

	stickyHeader() {
		const headerDOM = $('.header__container');

		const updateHeader = (config) => {
			const { position } = config;

			if (position.toFixed(3) > 0) {
				headerDOM.addClass('header__container--fixed');
			} else {
				headerDOM.removeClass('header__container--fixed');
			}
		};

		ScrollTrigger.create({
			trigger: '.header__sticky-start',
			start: 'top top',
			endTrigger: '.footer',
			end: 'bottom bottom',
			onRefresh: (self) => updateHeader({ position: self.progress }),
			onUpdate: (self) => updateHeader({ position: self.progress }),
		});
	}
}

new Gsap();
